var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootterKb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16663 4.16683C4.16663 3.94582 4.25442 3.73385 4.4107 3.57757C4.56698 3.42129 4.77895 3.3335 4.99996 3.3335H6.66663C6.88764 3.3335 7.0996 3.42129 7.25588 3.57757C7.41216 3.73385 7.49996 3.94582 7.49996 4.16683V15.8335C7.49996 16.0545 7.41216 16.2665 7.25588 16.4228C7.0996 16.579 6.88764 16.6668 6.66663 16.6668H4.99996C4.77895 16.6668 4.56698 16.579 4.4107 16.4228C4.25442 16.2665 4.16663 16.0545 4.16663 15.8335V4.16683Z",
    stroke: "#F6F7F8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.16683C7.5 3.94582 7.5878 3.73385 7.74408 3.57757C7.90036 3.42129 8.11232 3.3335 8.33333 3.3335H10C10.221 3.3335 10.433 3.42129 10.5893 3.57757C10.7455 3.73385 10.8333 3.94582 10.8333 4.16683V15.8335C10.8333 16.0545 10.7455 16.2665 10.5893 16.4228C10.433 16.579 10.221 16.6668 10 16.6668H8.33333C8.11232 16.6668 7.90036 16.579 7.74408 16.4228C7.5878 16.2665 7.5 16.0545 7.5 15.8335V4.16683Z",
    stroke: "#F6F7F8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16663 6.6665H7.49996",
    stroke: "#F6F7F8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.3335H10.8333",
    stroke: "#F6F7F8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5026 3.80012L13.3226 3.35845C13.7909 3.24595 14.2667 3.51678 14.3909 3.96845L17.4701 15.1501C17.5244 15.3548 17.5003 15.5724 17.4026 15.7603C17.3049 15.9482 17.1405 16.0929 16.9417 16.1659L16.8309 16.2001L15.0109 16.6418C14.5426 16.7543 14.0667 16.4835 13.9426 16.0318L10.8634 4.85012C10.8091 4.64541 10.8331 4.42779 10.9309 4.23989C11.0286 4.05199 11.1929 3.90735 11.3917 3.83428L11.5026 3.80012Z",
    stroke: "#F6F7F8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 7.49984L15 6.6665",
    stroke: "#F6F7F8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 13.3333L16.6025 12.5166",
    stroke: "#F6F7F8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootterKb);
export default __webpack_public_path__ + "static/media/footter_kb.3da2981b190b01b1bd100c8ee125b37d.svg";
export { ForwardRef as ReactComponent };